{
  "Samsung": {
    "Galaxy S26 Ultra": [
      "SM-S948"
    ],
    "Galaxy S26+": [
      "SM-S947"
    ],
    "Galaxy S26": [
      "SM-S942"
    ],
    "Galaxy S23 FE": [
      "SM-S711"
    ],
    "Galaxy S22 Ultra": [
      "SM-S908",
      "SCG14",
      "SC-52C"
    ],
    "Galaxy S22+": [
      "SM-S906"
    ],
    "Galaxy S22": [
      "SM-S901",
      "SC-51C",
      "SCG13"
    ],
    "Galaxy S21 Ultra 5G": [
      "SM-G998",
      "SCG10",
      "SC-52B"
    ],
    "Galaxy S21+ 5G": [
      "SM-G996",
      "SCG10"
    ],
    "Galaxy S21 5G": [
      "SM-G991",
      "SC-51B",
      "SCG09"
    ],
    "Galaxy S21 FE 5G": [
      "SM-G990"
    ],
    "Samsung Galazy Z Fold 3": [
      "SM-F926"
    ],
    "Samsung Galaxy Z Flip 3": [
      "SM-F711"
    ],
    "Galaxy A72": [
      "SM-A725"
    ],
    "Galaxy A53": [
      "SM-A536",
      "SCG15",
      "SC-53C"
    ],
    "Galaxy A52 5G": [
      "SM-A526",
      "SM-A528",
      "SC-53B"
    ],
    "Galaxy A52s 5G": [
      "SM-A528"
    ],
    "Galaxy A52": [
      "SM-A525"
    ],
    "Galaxy A35 5G": [
      "SM-A356"
    ],
    "Galaxy A26 5G": [
      "SM-A266"
    ],
    "Galaxy A25 5G": [
      "SM-A256"
    ],
    "Galaxy A17 5G": [
      "SM-A176"
    ],
    "Galaxy A16 5G": [
      "SM-A165"
    ]
  },
  "Pixel": {
    "Pixel 10a": [
      "Pixel 10a",
      "GE1GQ",
      "GV0BP",
      "G4H7L"
    ],
    "Pixel Fold": [
      "Pixel Fold",
      "G9FPL"
    ],
    "Pixel 7a": [
      "Pixel 7a",
      "GWKK3",
      "GHL1X",
      "G0DZQ",
      "G82U8"
    ],
    "Pixel 7 pro": [
      "Pixel 7 Pro",
      "GP4BC",
      "GE2AE",
      "GFE4J"
    ],
    "Pixel 7": [
      "Pixel 7",
      "GVU6C",
      "GQML3",
      "GO3Z5"
    ],
    "Pixel 6 pro": [
      "Pixel 6 Pro",
      "GLUOG",
      "G8VOU",
      "GF5KQ"
    ],
    "Pixel 6a": [
      "Pixel 6a",
      "GX7AS",
      "GB62Z",
      "G1AZG",
      "GB17L"
    ],
    "Pixel 6": [
      "Pixel 6",
      "GB7N6",
      "G9S9B16",
      "G9S9B",
      "GR1YH"
    ],
    "Pixel 5a 5G": [
      "Pixel 5a (5G)",
      "G1F8F",
      "G4S1M"
    ],
    "Pixel 5": [
      "Pixel 5",
      "GD1YQ",
      "GTT9Q",
      "G5NZ6"
    ],
    "Pixel 4a 5G": [
      "Pixel 4a (5G)"
    ]
  },
  "Motorola": {
    "Moto G (2025)": [
      "Moto G (2025)",
      "PB5X0002US",
      "XT2513",
      "T2513"
    ],
    "Razr (2023)": [
      "Razr (2023)",
      "XT2323"
    ],
    "Edge (2023)": [
      "Edge (2023)",
      "XT2305"
    ],
    "ThinkPhone": [
      "ThinkPhone",
      "Think Phone",
      "XT2309"
    ]
  },
  "OnePlus": {
    "OnePlus Open": [
      "OnePlus Open",
      "CPH2551"
    ],
    "OnePlus 13": [
      "OnePlus 13",
      "CPH2655",
      "CPH2653",
      "PJZ110",
      "CPH2649"
    ],
    "OnePlus 13R": [
      "OnePlus 13R",
      "CPH2645",
      "CPH2691",
      "CPH2647"
    ],
    "OnePlus 12": [
      "OnePlus 12",
      "PJD110",
      "CPH2573",
      "CPH2581",
      "CPH2583"
    ],
    "OnePlus 12R": [
      "OnePlus 12R",
      "CPH2609",
      "CPH2585",
      "CPH2611"
    ],
    "OnePlus 8T": [
      "KB200",
      "OnePlus 8T"
    ],
    "OnePlus 9 Pro": [
      "LE212",
      "OnePlus 9 Pro"
    ],
    "OnePlus 9R": [
      "OnePlus 9R",
      "LE210"
    ],
    "OnePlus 9": [
      "LE211",
      "OnePlus 9"
    ],
    "OnePlus 10 Pro": [
      "NE221",
      "OnePlus 10 Pro",
      "OnePlus 10 Pro 5G"
    ],
    "OnePlus 10T": [
      "CPH241",
      "OnePlus 10T"
    ],
    "OnePlus 10R": [
      "CPH2411",
      "OnePlus 10R"
    ],
    "OnePlus 10 Pro 5G": [
      "OnePlus 10 Pro 5G",
      "NE2210",
      "NE2211",
      "NE2213",
      "NE2215",
      "NE2217"
    ],
    "OnePlus 11 5G": [
      "PHB110",
      "CPH2449",
      "CPH2447",
      "OnePlus 11 5G"
    ],
    "OnePlus Nord N30 5G": [
      "OnePlus Nord N30 5G",
      "CPH2515",
      "CPH2513"
    ]
  },
  "Xiaomi": {
    "XIAOMI 12T Pro": [
      "12T Pro",
      "22081212G",
      "22081212UG"
    ]
  }
}